import {
  valueRepresentationOptions,
  ValueRepresentation,
} from '../types/scales.js';

/**
 * Returns true if valueRepresenation is a valid ValueRepresentation
 * @param valueRepresentation - value representation
 */
export const isValidValueRepresentation = (
  valueRepresentation: string,
): valueRepresentation is ValueRepresentation =>
  (valueRepresentationOptions as unknown as string[]).includes(
    valueRepresentation,
  );
